export default __webpack_public_path__ + "static/char-14-anr-88e72fdd1816114d71157032b028e9f9.gif";